import cx from "classnames";
import { faAngleLeft, faAngleRight, faEllipsisH } from "@fortawesome/pro-regular-svg-icons";

import { IPaginator } from "common/types";
import { pluralized } from "common/utils/strings";
import { getPageOptions } from "common/utils/pagination";
import Icon from "common/components/Icon";

import { useBreakpoints } from "client/common/hooks";

import styles from "../../styles/Pagination.module.less";

type PaginationProps = {
  paginator: IPaginator;
  onPageChange: (page: number) => void;
  entityName: string;
};

const Pagination = ({ paginator, onPageChange, entityName }: PaginationProps) => {
  const { isTabletPortraitAndSmaller } = useBreakpoints();
  const options = getPageOptions(paginator, { extraPages: isTabletPortraitAndSmaller ? 0 : 3 });

  if (options.totalPages <= 1) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.buttons}>
        <button
          type="button"
          disabled={!options.canPrevious}
          className={cx(styles.button, styles.arrow)}
          onClick={() => onPageChange(options.previousPage)}
        >
          <Icon icon={faAngleLeft} />
        </button>
        {options.showFirstPage && (
          <button
            type="button"
            className={styles.button}
            onClick={() => onPageChange(options.firstPage)}
          >
            {options.firstPage}
          </button>
        )}
        {options.showFirstDots && (
          <button type="button" disabled={true} className={styles.button}>
            <Icon icon={faEllipsisH} />
          </button>
        )}
        {options.pages.map((page) => (
          <button
            type="button"
            key={page}
            className={cx(styles.button, paginator.page === page && styles.active)}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}
        {options.showLastDots && (
          <button type="button" disabled={true} className={styles.button}>
            <Icon icon={faEllipsisH} />
          </button>
        )}
        {options.showLastPage && (
          <button
            type="button"
            className={styles.button}
            onClick={() => onPageChange(options.lastPage)}
          >
            {options.lastPage}
          </button>
        )}
        <button
          type="button"
          disabled={!options.canNext}
          className={cx(styles.button, styles.arrow)}
          onClick={() => onPageChange(options.nextPage)}
        >
          <Icon icon={faAngleRight} />
        </button>
      </div>
      <div className={styles.description}>
        {paginator.page_start_index}-{paginator.page_end_index} of {paginator.count}{" "}
        {pluralized(paginator.count, entityName)}
      </div>
    </div>
  );
};

export default Pagination;
